<template>
    <div class="issued-task-item" @click="locationTo('ybt/task/handleForMobile.htm?taskId='+item.taskId)">
        <Panel
                :img="getAvatarByUUID(item.starterUUID)"
                :title="item.taskName"
                :tagArr="tagArr"
                :descArr="descArr"
                :btnArr="btnArr"
                @btnClick="locationTo('ybt/task/handleForMobile.htm?taskId='+item.taskId)"
        />
    </div>
</template>

<script>
    import {getAvatarByUUID} from '@/utils/commons'
    import {locationTo,complete} from '@/utils/url'
    import Panel from '@/components/Panel/Panel'
    import moment from 'moment'

    export default {
        name: 'IssuedTaskItem',
        components: {
            Panel,
        },
        props: ['item'],
        data() {
            return {}
        },
        computed: {
            parsedStatus() {
                let parsedStatus
                const now = moment().unix(),
                    startTime = moment(this.item.startTime).unix(),
                    endTime = moment(this.item.endTime).unix()
                if (this.item.taskStatus == '0') {
                    parsedStatus = 0
                } else if (this.item.taskStatus == '1') {
                    if (moment(now).isBefore(startTime)) {
                        parsedStatus = 1
                    } else if (moment(now).isAfter(startTime) && moment(now).isBefore(endTime)) {
                        parsedStatus = 2
                    } else if (moment(now).isAfter(endTime)) {
                        parsedStatus = 3
                    }
                }
                return parsedStatus
            },
            tagArr() {
                let result = {}

                if (this.parsedStatus == 0) {
                    result.text = '已暂停'
                    result.color = '#FFBE00'
                } else if (this.parsedStatus == 1) {
                    result.text = '未开始'
                    result.color = '#AAAAAA'
                } else if (this.parsedStatus == 2) {
                    result.text = '进行中'
                    result.color = '#04BE02'
                } else if (this.parsedStatus == 3) {
                    result.text = '已结束'
                    result.color = '#EF4F4F'
                }

                return [result]
            },
            descArr() {
                return [
                    {key: '发起部门', value: this.item.starteDeptName},
                    {key:'开始时间',value: moment(this.item.startTime).format("YYYY-MM-DD HH:mm")},
                    {key: '截止时间', value: moment(this.item.endTime).format("YYYY-MM-DD HH:mm")},
                    {key: '上报进度', value: {'1': '未读', '2': '已读', '3': '已上报', '4': '已完成'}[this.item.status]},
                ]
            },
            btnArr() {
                let btnArr = []
                if (/^(1|2)$/.test(this.item.status)) {
                    if (this.parsedStatus == 2) btnArr = [{text: '开始上报', event: 'btnClick'}]
                } else {
                    btnArr = [{text: '查看详情', event: 'btnClick'}]
                }

                return btnArr
            },
        },
        mounted() {
        },
        methods: {
          locationTo, getAvatarByUUID,complete
        }
    }
</script>

<style scoped lang="scss">
    .issued-task-item {
      border-radius: 6px;
    }
</style>
